module.exports = __webpack_public_path__ + "static/media/basketball-ball.0a7741ea.svg";